document.addEventListener('DOMContentLoaded', setupProductAddOnInformationToggle);

function setupProductAddOnInformationToggle() {
  var buttons = document.querySelectorAll('.product-add-on--toggle-info-btn');
  var popups = document.querySelectorAll('.product-add-on--information');
  buttons.forEach(setupButton);
  popups.forEach(setupPopup);

  function setupButton(button) {
    var controls = button.getAttribute('aria-controls');
    var popup = document.getElementById(controls);
    button.addEventListener('click', togglePopup);

    function togglePopup(ev) {
      ev.preventDefault();
      popup.show();
    }
  }

  function setupPopup(dialog) {
    var closeButton = dialog.querySelector('.product-add-on--information-close');
    closeButton.addEventListener('click', closePopup);

    function closePopup(ev) {
      dialog.close();
    }
  }
}
